<template>
  <UAlert
    icon="i-lucide-info"
    title="Systemanforderungen"
    :description="description"
    variant="subtle"
    :ui="{
      title: 'text-primary-900 dark:text-primary-200',
      description: 'text-primary-800 dark:text-primary-300',
    }"
    :actions="actions"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { getDocsUrl } from '@/utils/docs-links'

interface ChangelogAlertAction {
  label: string
  to: string
  target?: string
  icon?: string
  color?: string
  variant?: string
}

const props = defineProps({
  description: {
    type: String,
    required: true,
  },
  releaseType: {
    type: String as () => 'microtech' | 'connectelo',
    default: undefined,
  },
})

const actions = computed(() => {
  const items: ChangelogAlertAction[] = [
    {
      label: 'Zu den Anforderungen',
      to: getDocsUrl('changelog'),
      target: '_blank',
      icon: 'i-lucide-external-link',
      color: 'primary',
    },
  ]

  if (props.releaseType) {
    items.push({
      label: 'Releases',
      to: `/releases?type=${props.releaseType}`,
      icon: 'i-heroicons-rocket-launch',
      color: 'neutral',
      variant: 'outline',
    })
  }

  return items
})
</script>
